var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:("timeline-btn " + (_vm.isActive ? 'active' : '')),attrs:{"data-bs-toggle":"collapse","data-bs-target":"#collapseWidthExample"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }